import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchPorts } from "../features/ports/portSlice";

import PortForm from "./PortForm";
import PortTable from "./PortTable";

function Ports() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.despatcho
    );

    useEffect(() => {

        dispatch(fetchPorts());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-4">

                    <PortForm />

                </div>

                <div className="col-lg-8">

                    <PortTable />

                </div>

            </div>

        </div>

    );

}

export default Ports;